import {Component} from "react";
import request from "request-promise-native";
import Alert from "react-bootstrap/lib/Alert";
import Form from "react-bootstrap/lib/Form";
import FormGroup from "react-bootstrap/lib/FormGroup";
import InputGroup from "react-bootstrap/lib/InputGroup";
import FormControl from "react-bootstrap/lib/FormControl";
import ProgressBar from "react-bootstrap/lib/ProgressBar";
import Button from "react-bootstrap/lib/Button";
import React from "react";
import Col from "react-bootstrap/lib/Col";
import ValidatedFormComponent from "./ValidatedFormComponent";
import Modal from "react-responsive-modal";

const RESET_PASSWORD_ENDPOINT = "https://qibipay.azurewebsites.net/api/PasswordReset";

const EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

class ForgotPassword extends Component {
    constructor(props) {

        /*
            Props:
             - login
         */

        super(props);
        this.state = {
            loading: false,
            showSuccessModal: false
        };
    }

    async logIn() {
        if(this.mailRef.validated()) {

            this.setState({loading: true, errorMessage: null});
            //Req to ms azure

            const options = {
                method: 'POST',
                uri: RESET_PASSWORD_ENDPOINT,
                body: {
                    mail: this.mailRef.value
                },
                json: true,
                resolveWithFullResponse: true,
                simple: false
            };

            const response = await request(options);

            this.setState({loading: false});

            if(response.statusCode!=200) {
                this.setState({errorMessage:response.body.msg});
                return;
            }

            this.setState({
                showSuccessModal: true
            });

        }
    }

    render() {
        return (
            <div className="auth-wrapper d-flex no-block justify-content-center align-items-center bg-dark">
                <div className="auth-box bg-dark border-top border-secondary">
                    <div id="loginform">
                        <div className="text-center p-t-10 p-b-10">
                            <span className="db" style={{color:'white'}}><p>Enter your e-mail address and we will send you a link where you can change your password!</p></span>
                        </div>

                        <Modal open={this.state.showSuccessModal}
                               onClose={() => this.setState({showSuccessModal: false})}>
                            <h2>Password reset link sent!</h2>
                            <p>Link for password reset has been sent to your e-mail address, check your inbox.</p>
                            <Button bsStyle="success" onClick={this.props.login}>Proceed to login page</Button>
                        </Modal>

                        <div className="form-horizontal m-t-20" id="loginform">
                            <div className="row p-b-10">
                                <div className="col-12">
                                    <Form horizontal>
                                        <ValidatedFormComponent type="text"
                                                                placeholder="Enter your e-mail address"
                                                                onValidate={input => {
                                                                    if(!EMAIL_REGEX.test(input)) return "Not a valid e-mail!";
                                                                    return null;
                                                                }}
                                                                inputRef={ref => this.mailRef=ref}
                                        />
                                    </Form>
                                    {this.state.errorMessage!=null ? (<Alert bsStyle="danger">
                                        <strong>{this.state.errorMessage}</strong>
                                    </Alert>) : ''}
                                    {this.state.loading ? (<div className="p-t-30">
                                        <ProgressBar  active now={100} bsStyle="success" />;
                                    </div>) : ''}
                                </div>
                            </div>
                            <div className="row border-top border-secondary">
                                <div className="col-12">
                                    <div className="form-group">
                                        <div className="p-t-20">
                                            <Button bsStyle="success" onClick={this.props.login}>
                                                Back To Login
                                            </Button>

                                            <Button disabled={this.state.loading} onClick={this.logIn.bind(this)} bsStyle="primary" className="btn float-right">
                                                {this.state.loading ? 'Resetting password...' : 'Reset Password'}
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <p></p>
                    </div>
                </div>
            </div>
        );
    }
}

export default ForgotPassword;